import api from '../../../../../configurations/service';
import * as types from './mutation-types';

export const setCSTCollection = async (context, search) => {
  const body = { active: true, search };
  const { data } = await api().post('fiscal.get-cst', body);
  const collection = data.map((e) => ({ ...e, text: e.descricao, value: e }));
  context.commit(types.SET_CST_COLLECTION, collection);
};

export const setCSTIPICollection = async (context, search) => {
  const body = { active: true, search };
  const { data } = await api().post('fiscal.get-cstipi', body);
  const collection = data.map((e) => ({ ...e, text: e.descricao, value: e }));
  context.commit(types.SET_CST_IPI_COLLECTION, collection);
};

export const setCSTPISCollection = async (context, search) => {
  const body = { active: true, search };
  const { data } = await api().post('fiscal.get-cstpis', body);
  const collection = data.map((e) => ({ ...e, text: e.descricao, value: e }));
  context.commit(types.SET_CST_PIS_COLLECTION, collection);
};

export const setCSTCOFINSCollection = async (context, search) => {
  const body = { active: true, search };
  const { data } = await api().post('fiscal.get-cstcofins', body);
  const collection = data.map((e) => ({ ...e, text: e.descricao, value: e }));
  context.commit(types.SET_CST_COFINS_COLLECTION, collection);
};
